








































































































































import Component from 'vue-class-component';
import { IDictionary } from '@/entities/dictionary.interface';
import { IFormControl } from '@/entities/form.interface';
import { EditPage } from '@/components/base/edit/edit-page';
import officesApi from '@/api/offices.api';
import { IListItem } from '@/entities/list-item.interface';
import sitesApi from '@/api/sites.api';
import { IOfficeDetail } from '@/entities/offices/office-detail.interface';

const passwordDefaultValidator = 'confirmed:passwordConfirm';

@Component({})
export default class OfficesEdit extends EditPage {
    public parentPath: string = '/app/offices';

    public sites: IListItem[] = [];
    public sitesLoading: boolean = false;

    public formState: IDictionary<IFormControl> = {
        officeName: {
            key: 'officeName',
            label: 'Office Name',
            value: '',
            validators: 'required'
        },
        manFirstName: {
            key: 'manFirstName',
            label: `Manager's First Name`,
            value: '',
            validators: 'required'
        },
        manLastName: {
            key: 'manLastName',
            label: `Manager's Last Name`,
            value: '',
            validators: 'required'
        },
        // manEmail: {
        //     key: 'manEmail',
        //     label: 'Email',
        //     value: '',
        //     validators: 'required|email'
        // },
        username: {
            key: 'username',
            label: 'Username',
            value: '',
            validators: 'required'
        },
        password: {
            key: 'password',
            label: 'Password',
            value: '',
            validators: passwordDefaultValidator
        },
        passwordConfirm: {
            key: 'passwordConfirm',
            label: 'Confirm Password',
            value: '',
            validators: ''
        },
        agentNotes: {
            key: 'agentNotes',
            label: 'Must Read (optional)',
            value: ''
        },
        active: {
            key: 'active',
            label: 'Activated',
            value: false
        },
        hidden: {
            key: 'hidden',
            label: 'Hidden',
            value: false
        },
        siteIds: {
            key: 'siteIds',
            label: 'Sites',
            value: []
        }
    };

    public async created() {
        super.created();
        await this._loadSites();
        if (this.isNew) {
            this.formState = {
                ...this.formState,
                password: {
                    ...this.formState.password,
                    validators: passwordDefaultValidator + '|required'
                },
                passwordConfirm: {
                    ...this.formState.passwordConfirm,
                    validators: 'required'
                }
            };
            this.formState.siteIds.value = this.sites.map((x) => x.value);
            this.formState.active.value = true;
        }
    }

    // TODO own resourse service will be nice for api calls
    public detail(companyId: number): Promise<IOfficeDetail> {
        return officesApi.get(companyId);
    }

    public create(body: any): Promise<number> {
        return officesApi.create(body);
    }

    public update(body: any): Promise<number> {
        return officesApi.update(this.id, body);
    }

    private async _loadSites() {
        this.sitesLoading = true;
        try {
            const items = await sitesApi.list();
            const mapped = items.map((x) => {
                return { value: x.id, heading: x.sitename };
            });
            this.sites = mapped;
        } finally {
            this.sitesLoading = false;
        }
    }
}
